import React from 'react'
import { formatTimeDiff } from './MessagingProvider'
import safeParse from '~/lib/safeParse'
import { DeleteMessageDialog } from './DeleteThreadDialog'

const CoachMessage = ({
  message,
  coach,
  candidateName,
  userIsCoach,
  linkToCandidate,
  liaisonImageUrl,
  coachIsLiaison,
  automated,
  countryLanguage,
  countryFlag,
  locale,
  t,
}) => {
  const {
    coach_is_sender: coachIsSender,
    body,
    created_at: createdAt,
    attachment: { url: attachmentUrl },
    attachment_filename: attachmentFilename,
  } = message || {}
  const {
    full_name: coachName,
    photo_preview_url: coachPhotoUrl,
    transparent_photo_preview_url: coachTransparentPhotoUrl,
  } = coach || {}
  const photoUrl =
    coachIsLiaison || automated
      ? liaisonImageUrl
      : coachTransparentPhotoUrl || coachPhotoUrl
  const senderName = coachIsSender
    ? automated
      ? t('coaching_team')
      : coachIsLiaison
        ? t('coach_liaison_team')
        : coachName
    : candidateName

  const containerClass =
    'group mb-4 scroll-mb-4 pb-4 border-b border-silver last:border-b-0'

  return (
    <div className={containerClass}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row items-center justify-between gap-2">
          <div className="flex min-w-0 flex-row items-center">
            {coachIsSender && photoUrl && (
              <div className="mr-2 flex h-12 w-12 items-center justify-center rounded-full bg-willow-brook">
                <img src={photoUrl} alt="Coach Photo" className="max-h-6" />
              </div>
            )}
            <div className="text-xl font-medium">
              {userIsCoach && !coachIsSender ? (
                <a
                  href={linkToCandidate}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {senderName}
                </a>
              ) : (
                senderName
              )}
              {userIsCoach && (
                <div className="flex items-center gap-2">
                  <span className="text-sm text-mine-shaft-500">
                    {countryLanguage}
                  </span>
                  <i className={`glyphicon mb-1 bfh-flag-${countryFlag}`}></i>
                </div>
              )}
            </div>
          </div>
          <div className="opacity-0 transition-opacity focus-within:opacity-100 group-hover:opacity-100 [@media(hover:none)]:opacity-100">
            <DeleteMessageDialog message={message} />
          </div>
        </div>
        <div className="min-w-0 overflow-hidden [overflow-wrap:anywhere] [&_P]:text-left [&_P]:[overflow-wrap:anywhere]">
          {safeParse(
            body
              .replace(/&nbsp;/g, ' ')
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/&quot;/g, '"')
              .replace(/&#39;|&amp;#39;/g, "'"),
          )}
          {attachmentUrl && (
            <a
              rel="noreferrer"
              href={attachmentUrl}
              className="my-2 inline-block"
              download
            >
              {attachmentFilename}
            </a>
          )}
        </div>
        <div>{formatTimeDiff(createdAt, locale)}</div>
      </div>
    </div>
  )
}
export default CoachMessage
